//@flow
import React, {useState} from 'react';
import CustomModal from '../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import GreenConfig from '../../../assets/img/onboarding/green-config.png';
import WelcomeBanner from '../../../assets/img/onboarding/step-by-step-welcome-banner.webp';

type Props = {
  onClose: () => void,
};

const useStyles = makeStyles(theme => ({
  modal: {
    padding: '2rem 1rem',
    borderRadius: '1.5rem',
    margin: '0 auto',
    width: '95%',
    maxWidth: '600px',
    [theme.breakpoints.up('sm')]: {
      padding: '2rem 3rem',
    },
  },
  root: {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
    overflow: 'hidden',
  },
  headerIcon: {
    margin: '0 auto',
    width: '85px',
    height: '85px',
    display: 'flex',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '1rem',
    textAlign: 'center',
  },
  textBold: {
    fontWeight: 600,
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    aspectRatio: '1',
    borderRadius: '1.25rem',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  btnFilled: {
    padding: '.5rem 2rem',
    background: '#F7D144',
    color: '#18003D',
    borderRadius: '2rem',
    fontWeight: 600,
    width: '100%',
    margin: '0 auto',

    [theme.breakpoints.up('sm')]: {
      width: '60%',
    },
  },
}));

export default function WelcomeModal({onClose}: Props) {
  const classes = useStyles();

  const [modalOpen, setModalOpen] = useState(true);

  const handleClose = () => {
    onClose();
    setModalOpen(false);
  };

  const handleClick = () => {
    handleClose();
  };

  return (
    <CustomModal
      open={modalOpen}
      handleCloseModal={handleClose}
      classes={{paper: classes.modal}}
    >
      <div className={classes.root}>
        <picture className={classes.headerIcon}>
          <img src={GreenConfig} alt="tuerca verde" />
        </picture>
        <Typography className={classes.title}>
          ¡Tu tienda virtual fue creada!
        </Typography>

        <picture className={classes.image}>
          <img
            src={WelcomeBanner}
            alt="Sácale el máximo provecho a tu tienda"
          />
        </picture>

        <CustomButton
          className={classes.btnFilled}
          href={
            'https://calendly.com/estefano-tiendada/onboarding-1-1-backoffice'
          }
          target={'_blank'}
          onClick={handleClick}
          rel={'noopener noreferrer'}
        >
          Agendar reunión
        </CustomButton>
      </div>
    </CustomModal>
  );
}
